import React from 'react';
import s from './Contacts.module.css';

export const Contacts = () => (
    <div className={s.help}>
        <span>{i18next.t('Contacts.return.help.text')}</span>{' '}
        <a href="mailto:support@smetter.ru" className={s.helpMail}>
            {' '}
            support@smetter.ru
        </a>
        <span className={s.separator} />
        <a href="tel:+78007753462" className={s.helpPhone}>
            8 800 775 34 62
        </a>
    </div>
);
